import { faker } from '@faker-js/faker';

import type { ResendConfirmationCodePostResponse } from '../types/ResendConfirmationCodePostResponse';

export function createResendConfirmationCodePostResponse(
  data: NonNullable<Partial<ResendConfirmationCodePostResponse>> = {}
): NonNullable<ResendConfirmationCodePostResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
